import { PresetWithMergeableCSS } from '@bas/ui/optimus-ui';
import { StyleOptions } from '@openng/optimus-ui-themes';

export const customerOverride = {
	components: {
		button: {
			extend: {
				minWidth: '155px',
			},
		},
	},
	css: ({}: StyleOptions, css: string) => `
		${ css }
		:is(div, .bui-field) > :is(.p-checkbox, .p-radiobutton):first-child:has(+ label:last-child) {
			translate: 0 5px;
		}
	`,
} satisfies PresetWithMergeableCSS;